import React from "react";
import Button from "monday-ui-react-core/dist/Button";
import ErrorImage from "./default-error-icon.png";
import "./default-error-component.scss";

const ERROR_LABEL = "Oops... Something went wrong on our end";
const DEFAULT_BUTTON_LABEL = "Refresh Page";

const refreshPage = () => {
  window.location.reload();
};

const DefaultErrorComponent = ({ onContactSupportClicked }) => {
  return (
    <div className="default-error-component">
      <div className="error-image">
        <img src={ErrorImage} alt={ERROR_LABEL} />
      </div>
      <div className="error-label">{ERROR_LABEL}</div>
      <div className="help-suggestion">
        Try refreshing the page or&nbsp;
        <span className="contact-support" onClick={onContactSupportClicked}>
          Contact Support
        </span>
      </div>
      <div className="refresh-app-wrapper">
        <Button onClick={refreshPage}>{DEFAULT_BUTTON_LABEL}</Button>
      </div>
    </div>
  );
};

DefaultErrorComponent.defaultProps = {
  onContactSupportClicked: () => {}
};

export default DefaultErrorComponent;
